import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startCourseActivities = (course, data, proxyUser) => {
  const root = createRoot(document.getElementById('courseActivitiesApp'))
  root.render(<App course={course} data={data} proxyUser={proxyUser} />)
}
